<template>
  <PageLayout
    :is-loading="isLoading"
    page-title="Campaign"
    :show-banner="true"
    :banner-items="bannerItems"
    :banner-location="'campaign'"
    :show-sponsors="false"
    @banner-click="handleBannerClick"
  >
    <!-- Campaign Stats Section -->
    <div class="campaign-stats-section">
      <div class="stats-container">
        <div class="stat-item clickable" @click="goToCampaignHistory">
          <div class="stat-icon">
            <i class="mdi mdi-bullhorn"></i>
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ campaignStats.active || 0 }}</div>
            <div class="stat-label">Campaign Saya</div>
          </div>
        </div>
        
        <div class="stat-item clickable" @click="goToCampaignHistory">
          <div class="stat-icon">
            <i class="mdi mdi-check-circle"></i>
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ campaignStats.completed || 0 }}</div>
            <div class="stat-label">Campaign Selesai</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Campaign Terfavorit Section -->
    <div class="campaign-section">
      <div class="section-header">
        <h3 class="section-title">Campaign Terfavorit</h3>        
      </div>
      
      <!-- Empty State for Featured Campaigns -->
      <div v-if="featuredCampaigns.length === 0" class="empty-state">
        <div class="empty-state-icon">
          <i class="mdi mdi-bullhorn-outline"></i>
        </div>
        <h4 class="empty-state-title">Belum Ada Campaign</h4>
        <p class="empty-state-description">
          Saat ini belum ada campaign yang tersedia. Silakan cek kembali nanti untuk campaign terbaru!
        </p>
      </div>
      
      <div v-else class="campaign-grid">
        <div v-for="(campaign, index) in featuredCampaigns" :key="index" class="campaign-card">
          <div class="campaign-image">
            <img :src="campaign.logo_brand || require('@/assets/cta-background.png')" :alt="campaign.name" class="campaign-photo" />
            <div class="campaign-overlay">
              <div class="campaign-category">{{ campaign.category }}</div>
            </div>
          </div>
          
          <div class="campaign-content">
            <div class="campaign-header">
              <h4 class="campaign-title">{{ campaign.name }}</h4>
              <div class="campaign-tags">
                <span v-for="(tag, tagIndex) in campaign.tipe_project.split(',')" :key="tagIndex" class="campaign-tag">
                  {{ tag.trim() }}
                </span>
              </div>
            </div>
            
            <div class="campaign-info">
              <div class="campaign-meta">
                <div class="campaign-deadline">
                  <i class="mdi mdi-clock-outline"></i>
                  Registrasi: {{ formatDate(campaign.end_reg) }}
                </div>
                <div class="campaign-quota">
                  <i class="mdi mdi-account-multiple"></i>
                  Dibutuhkan: {{ campaign.kuota }} Influencer
                </div>
                <!--div class="campaign-participants">
                  <i class="mdi mdi-account-group"></i>
                  {{ campaign.participant }} Peserta Terdaftar
                </div-->
              </div>
            </div>
            
            <div class="campaign-footer">
              <div class="campaign-benefits">
                <div class="benefit-item" v-if="campaign.benefit_point">
                  <i class="mdi mdi-star"></i>
                  <span>{{ campaign.benefit_point }} Points</span>
                </div>
                <div class="benefit-item" v-if="campaign.benefit_fee">
                  <i class="mdi mdi-cash"></i>
                  <span>{{ campaign.benefit_fee }} Fee</span>
                </div>
              </div>
              <button class="join-button" @click="viewCampaignDetail(campaign.campaign_id)">
                {{ getUserCampaignStatus(campaign) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Flash Campaign Section -->
    <!-- <div class="flash-campaign-section">
      <div class="flash-header">
        <h3 class="flash-title">Flash Campaign</h3>
        <span class="flash-badge">Terbatas</span>
      </div>
      
      <div class="flash-campaign-card">
        <div class="flash-content">
          <div class="flash-image">
            <img src="@/assets/cta-background.png" alt="Flash Campaign" class="flash-photo" />
          </div>
          <div class="flash-info">
            <h4 class="flash-campaign-title">Campaign Spesial Terbatas</h4>
            <p class="flash-description">Kesempatan terbatas untuk bergabung dengan campaign eksklusif</p>
            <button class="flash-join-button">Ikuti Sekarang</button>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Ikuti Sebelum Berakhir Section -->
    <div class="campaign-section">
      <div class="section-header">
        <h3 class="section-title">Ikuti Sebelum Berakhir!</h3>
      </div>
      
      <!-- Empty State for Urgent Campaigns -->
      <div v-if="urgentCampaigns.length === 0" class="empty-state">
        <div class="empty-state-icon">
          <i class="mdi mdi-clock-alert-outline"></i>
        </div>
        <h4 class="empty-state-title">Belum Ada Campaign</h4>
        <p class="empty-state-description">
          Saat ini sedang tidak ada campaign. Pantau terus untuk campaign baru!
        </p>
      </div>
      
      <div v-else class="campaign-list">
        <div v-for="(campaign, index) in urgentCampaigns" :key="index" class="campaign-list-item">
          <div class="campaign-list-image">
            <img :src="campaign.logo_brand || require('@/assets/cta-background.png')" :alt="campaign.name" class="list-photo" />
          </div>
          
          <div class="campaign-list-content">
            <h4 class="list-campaign-title">{{ campaign.name }}</h4>
            <div class="list-campaign-meta">
              <div class="list-campaign-deadline">
                <i class="mdi mdi-clock-outline"></i>
                {{ formatDate(campaign.end_reg) }}
              </div>
              <div class="list-campaign-urgency">
                <i class="mdi mdi-timer-sand"></i>
                {{ getDaysRemaining(campaign.end_reg) }}
              </div>
              <div class="list-campaign-quota">
                <i class="mdi mdi-account-multiple"></i>
                {{ campaign.kuota }} Influencer
              </div>
            </div>
          </div>
          
          <div class="campaign-list-action">
            <button class="list-join-button" @click="viewCampaignDetail(campaign.campaign_id)">
              Daftar
            </button>
          </div>
        </div>
      </div>
    </div>
  </PageLayout>
</template>

<script>
import AppPageLayout from '@/components/ui/PageLayout.vue';

export default {
  name: "NewCampaignUser",
  components: { 
    PageLayout: AppPageLayout
  },
  data() {
    return {
      isLoading: false,
      bannerItems: [],
      campaigns: [],
      campaignStats: {
        active: 0,
        completed: 0
      },
      detailUser: {}
    };
  },
  computed: {
    featuredCampaigns() {
      return [...this.campaigns]
        .sort((a, b) => {
          const participantsA = (a.user && a.user.length) ? a.user.length : 0;
          const participantsB = (b.user && b.user.length) ? b.user.length : 0;
          return participantsB - participantsA;
        })
        .slice(0, 2);
    },
    urgentCampaigns() {
      return [...this.campaigns]
        .filter(campaign => {
          return campaign.end_reg && campaign.end_reg !== '';
        })
        .sort((a, b) => {
          const dateA = new Date(a.end_reg);
          const dateB = new Date(b.end_reg);
          return dateA - dateB;
        })
        .slice(0, 5);
    }
  },
  methods: {
    loadCampaignStats() {
      const baseURI = this.$settings.endPoint + "campaign-user/select";
      return this.$http
        .get(baseURI, { 
          timeout: 10000,
          'headers': {
            'AppToken': this.$settings.jwtSecret,
          }
        })
        .then((response) => {
          const userCampaigns = response.data.datas || [];
          
          this.campaignStats.active = userCampaigns.length;
          
          this.campaignStats.completed = userCampaigns.filter(campaign => 
            campaign.status === 'BUKTI INSIGHT SUBMITTED'
          ).length;
        })
        .catch(error => {
          console.log('Error loading campaign stats:', error);
        });
    },
    
    loadBanners() {
      const baseURI = this.$settings.endPoint + "get-banner";
      this.isLoading = true;
      return this.$http
        .get(
          baseURI +
          `?limit=10&page=1&sort_field=&sort_type=&title=&link=&priority=&location=campaign`,
          {
            timeout: 10000,
            'headers': {
              'AppToken': this.$settings.jwtSecret,
            }
          }
        )
        .then((response) => {
          this.isLoading = false;
          this.bannerItems = response.data.datas;
        }).catch(error => {
          this.isLoading = false;
          console.log('Error:', error);
          this.handleError(error);
        });
    },
    
    loadCampaigns() {
      const baseURI = this.$settings.endPoint + "campaign";
      this.isLoading = true;
      return this.$http
        .get(
          baseURI +
          `?limit=20&page=1&sort_field=&sort_type=&source=Running&user_view=true`,
          { 
            timeout: 10000,
            'headers': {
              'AppToken': this.$settings.jwtSecret,
            }
          }
        )
        .then((response) => {
          this.isLoading = false;
          this.campaigns = response.data.datas.data || [];
          
          // Process campaigns to check user registration status
          this.campaigns.forEach((campaign) => {
            let checkUser = 0;
            if (campaign.user && campaign.user.length > 0) {
              campaign.user.forEach((user) => {
                if (user.user_id == this.detailUser.user_id) {
                  checkUser = 1;
                }
              });
            }
            campaign.statusDaftar = checkUser > 0 ? 1 : 0;
          });
        }).catch(error => {
          this.isLoading = false;
          console.log('Error:', error);
          this.handleError(error);
        });
    },
    
    goToCampaignHistory() {
      this.$router.push("/user/campaign-history");
    },
    
    handleBannerClick(banner) {
      console.log('Banner clicked:', banner);
      if (banner.link && banner.link !== '#') {
        window.open(banner.link, '_blank');
      }
    },
    
    viewCampaignDetail(campaignId) {
      // Check if user profile is complete
      if (this.detailUser.jenis_kelamin === null || this.detailUser.jenis_kelamin === undefined) {
        const baseURI = this.$settings.endPoint + "pengguna/check-reg/" + this.detailUser.user_id;
        return this.$http
          .get(baseURI, { timeout: 10000 })
          .then((response) => {
            let cek = response.data.datas;
            if (cek == 'ok') {
              this.$router.push(`/user/campaign-detail/${campaignId}`);
            } else {
              this.$swal({
                title: 'Warning',
                text: 'Mohon lengkapi terlebih dahulu profile anda',
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
              }).then(() => {
                this.$router.push("/user/profile/edit?section=basic");
              });
            }
          }).catch(error => {
            this.handleError(error);
          });
      } else {
        this.$router.push(`/user/campaign-detail/${campaignId}`);
      }
    },
    
    getUserCampaignStatus(campaign) {
      if (campaign.statusDaftar == 1) {
        return "Cek Status";
      } else {
        return "Daftar";
      }
    },
    
    getParticipantCount(campaign) {
      return (campaign.user && campaign.user.length) ? campaign.user.length : 0;
    },
    
    getDaysRemaining(dateString) {
      if (!dateString) return '';
      
      const endDate = new Date(dateString);
      const today = new Date();
      const diffTime = endDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      if (diffDays < 0) {
        return 'Berakhir';
      } else if (diffDays === 0) {
        return 'Hari ini';
      } else if (diffDays === 1) {
        return '1 hari lagi';
      } else {
        return `${diffDays} hari lagi`;
      }
    },
    
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('id-ID', { 
        day: 'numeric', 
        month: 'short', 
        year: 'numeric' 
      });
    },
    
    fetchUserData() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
    },
    
    handleError(error) {
      if (error.response) {
        if (error.response.status === 422) {
          console.error('Validation error:', error.response.data.errors);
        } else if (error.response.status === 500) {
          this.$router.push('/server-error');
        } else if (error.response.status === 401) {
          this.$router.push("/authorized-error");
        } else {
          this.$router.push('/page-not-found');
        }
      }
    },
  },
  mounted() {
    this.fetchUserData();
    this.loadCampaignStats();
    this.loadBanners();
    this.loadCampaigns();
  }
};
</script>

<style scoped>
/* ========================================= */
/* CAMPAIGN STATS SECTION                    */
/* ========================================= */
.campaign-stats-section {
  padding: 24px 32px;
  margin: 0 auto 32px auto;
  background: white;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  max-width: 1200px;
  width: calc(100% - 64px);
}

.stats-container {
  display: flex;
  gap: 24px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  padding: 20px;
  background: linear-gradient(135deg, #F2994A 0%, #F2C94C 100%);
  border-radius: 12px;
  color: white;
}

.stat-item.clickable {
  cursor: pointer;
  transition: all 0.3s ease;
}

.stat-item.clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(242, 153, 74, 0.3);
  cursor: pointer;
}

.stat-icon {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.stat-number {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1;
}

.stat-label {
  font-size: 0.9rem;
  opacity: 0.9;
}

/* ========================================= */
/* CAMPAIGN SECTION STYLES                   */
/* ========================================= */
.campaign-section {
  padding: 24px 32px;
  margin: 0 auto 32px auto;
  background: white;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  max-width: 1200px;
  width: calc(100% - 64px);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 8px;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.section-subtitle {
  font-size: 0.85rem;
  color: #6B7280;
  font-style: italic;
}

.view-all-link {
  color: #F2994A;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: color 0.3s ease;
}

.view-all-link:hover {
  color: #e0874a;
}

.campaign-saya-button {
  background: #F2994A;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.campaign-saya-button:hover {
  background: #e0874a;
  transform: translateY(-1px);
}

/* ========================================= */
/* CAMPAIGN GRID STYLES                      */
/* ========================================= */
.campaign-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

/* ========================================= */
/* EMPTY STATE STYLES                        */
/* ========================================= */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: #F9FAFB;
  border-radius: 12px;
  border: 2px dashed #E5E7EB;
}

.empty-state-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #F2994A 0%, #F2C94C 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2.5rem;
}

.empty-state-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1F2937;
  margin: 0 0 12px 0;
}

.empty-state-description {
  font-size: 0.95rem;
  color: #6B7280;
  margin: 0;
  max-width: 400px;
  margin: 0 auto;
  line-height: 1.6;
}

.campaign-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
}

.campaign-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.campaign-image {
  position: relative;
  height: 180px;
  overflow: hidden;
}

.campaign-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.campaign-card:hover .campaign-photo {
  transform: scale(1.05);
}

.campaign-overlay {
  position: absolute;
  top: 12px;
  left: 12px;
}

.campaign-category {
  background: rgba(242, 153, 74, 0.9);
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
}

.campaign-content {
  padding: 20px;
}

.campaign-header {
  margin-bottom: 16px;
}

.campaign-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1F2937;
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.campaign-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.campaign-tag {
  background: #E5F3FF;
  color: #1E40AF;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
}

.campaign-info {
  margin-bottom: 20px;
}

.campaign-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.campaign-deadline,
.campaign-quota,
.campaign-participants {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  color: #6B7280;
}

.campaign-deadline i,
.campaign-quota i,
.campaign-participants i {
  font-size: 1rem;
  color: #9CA3AF;
}

.campaign-participants {
  color: #F2994A;
  font-weight: 600;
}

.campaign-participants i {
  color: #F2994A;
}

.campaign-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid #F3F4F6;
}

.campaign-benefits {
  display: flex;
  gap: 12px;
}

.benefit-item {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #4A90E2;
  font-size: 0.8rem;
  font-weight: 600;
}

.benefit-item i {
  font-size: 0.9rem;
}

.join-button {
  background: #4A90E2;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.join-button:hover {
  background: #357ABD;
}

/* ========================================= */
/* FLASH CAMPAIGN STYLES                     */
/* ========================================= */
.flash-campaign-section {
  padding: 24px 32px;
  margin: 0 auto 32px auto;
  background: linear-gradient(135deg, #4A90E2 0%, #357ABD 100%);
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
  max-width: 1200px;
  width: calc(100% - 64px);
  color: white;
}

.flash-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.flash-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
}

.flash-badge {
  background: #DC2626;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
}

.flash-campaign-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 20px;
  backdrop-filter: blur(10px);
}

.flash-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.flash-image {
  width: 120px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.flash-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.flash-info {
  flex: 1;
}

.flash-campaign-title {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0 0 8px 0;
}

.flash-description {
  font-size: 0.9rem;
  opacity: 0.9;
  margin: 0 0 16px 0;
}

.flash-join-button {
  background: white;
  color: #4A90E2;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.flash-join-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* ========================================= */
/* CAMPAIGN LIST STYLES                      */
/* ========================================= */
.campaign-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.campaign-list-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border: 1px solid #EAECF0;
  border-radius: 12px;
  background: #fff;
  transition: box-shadow 0.2s, transform 0.2s;
}

.campaign-list-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.campaign-list-image {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 16px;
  flex-shrink: 0;
}

.list-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.campaign-list-content {
  flex: 1;
}

.list-campaign-title {
  font-size: 1rem;
  font-weight: 700;
  color: #1F2937;
  margin: 0 0 8px 0;
}

.list-campaign-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.list-campaign-deadline,
.list-campaign-quota,
.list-campaign-urgency {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  color: #6B7280;
}

.list-campaign-urgency {
  color: #DC2626;
  font-weight: 600;
}

.list-campaign-urgency i {
  color: #DC2626;
}

.campaign-list-action {
  margin-left: 16px;
}

.list-join-button {
  background: #4A90E2;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.list-join-button:hover {
  background: #357ABD;
}

/* ========================================= */
/* MOBILE RESPONSIVE STYLES                  */
/* ========================================= */
@media (max-width: 768px) {
  .campaign-stats-section,
  .campaign-section,
  .flash-campaign-section {
    width: calc(100% - 40px);
    margin: 0 20px 24px 20px;
    padding: 16px;
  }
  
  .stats-container {
    flex-direction: column;
    gap: 16px;
  }
  
  .stat-item {
    padding: 16px;
  }
  
  .stat-number {
    font-size: 1.5rem;
  }
  
  .section-header {
    margin-bottom: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .section-title {
    font-size: 1.1rem;
  }
  
  .section-subtitle {
    font-size: 0.8rem;
  }
  
  .view-all-link {
    font-size: 0.85rem;
  }
  
  .campaign-saya-button {
    font-size: 0.8rem;
    padding: 6px 12px;
  }

  .campaign-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .campaign-card {
    border-radius: 12px;
  }
  
  .campaign-image {
    height: 160px;
  }
  
  .campaign-content {
    padding: 16px;
  }
  
  .campaign-title { 
    font-size: 1rem; 
  }
  
  .campaign-footer {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  
  .join-button {
    width: 100%;
    justify-content: center;
    padding: 10px 16px;
  }

  .flash-content {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }
  
  .flash-image {
    width: 100%;
    height: 120px;
  }

  .campaign-list-item {
    padding: 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .campaign-list-image {
    width: 100%;
    height: 120px;
    margin-right: 0;
  }
  
  .campaign-list-action {
    margin-left: 0;
    width: 100%;
  }
  
  .list-join-button {
    width: 100%;
  }
  
  .empty-state {
    padding: 40px 20px;
  }
  
  .empty-state-icon {
    width: 60px;
    height: 60px;
    font-size: 2rem;
    margin-bottom: 16px;
  }
  
  .empty-state-title {
    font-size: 1.1rem;
  }
  
  .empty-state-description {
    font-size: 0.85rem;
  }
}
</style>